import { uppercaseFirstLetter } from "../../../utils";

export const REVIEW_TEMPLATE_COLUMNS = [
  {
    header: "Title",
    id: "title",
    accessorKey: "title",
  },
  {
    header: "Year",
    id: "year",
    accessorKey: "year",
  },
];

export const CONTRACTOR_COLUMNS = [
  {
    Header: "Contractor Name",
    id: "contractor_name",
    accessor: (row) =>
      `${uppercaseFirstLetter(row.firstName)}  ${uppercaseFirstLetter(
        row.lastName
      )} `,
  },
  {
    Header: "Task",
    id: "task",
    accessor: "task",
  },
  {
    Header: "Staffing Agency",
    id: "staffingAgency",
    accessor: "staffingAgency",
  },
];

export const PROJECT_CSV_COLUMNS = [
  {
    Header: "Project #",
    accessor: "project_num",
  },
  {
    Header: "Project Name",
    accessor: "name",
  },

  {
    Header: "Manager",
    accessor: "manager",
  },
  {
    Header: "Supervisor",
    accessor: "supervisor",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Address",
    accessor: "address",
  },
  { Header: "City", accessor: "city" },
  { Header: "State", accessor: "state" },
  { Header: "Zip", accessor: "zip" },
  { Header: "Notes", accessor: "notes" },
  { Header: "Partners", accessor: "employees" },
  { Header: "Contractors", accessor: "contractors" },
];
